module.exports = __webpack_public_path__ + "static/media/Cyclops.8c957d52.jpg";